<template>
	<div class="home_container">
		<pcHeader></pcHeader>
		<div v-if="routes.length > 1" class="breadcrumb">
			<a-breadcrumb :routes="routes">
				<template slot="itemRender" slot-scope="{ route, routes }">
					<span v-if="routes.indexOf(route) === routes.length - 1">{{
						route.meta.name
					}}</span>
					<router-link v-else to="/">{{
						route.meta.name
					}}</router-link>
				</template>
			</a-breadcrumb>
		</div>

		<router-view />

		<pcFooter></pcFooter>
		<div>
			<a-back-top class="backTop">
				<icon-font type="icon-huidingbu" />
			</a-back-top>
			<a-affix
				:style="{ position: 'fixed', right: 0 }"
				:offset-bottom="20"
			>
				<div style="position: relative;">
					<a-tooltip
						:getPopupContainer="
							(triggerNode) => {
								return triggerNode.parentNode
							}
						"
						placement="left"
					>
						<template slot="title">
							<div style="width: 120px;height: 120px;">
								<img
									style="width: 120px;height: 120px;"
									src="@/assets/advertising/code.jpg"
									alt
								/>
							</div>
						</template>
						<div class="affix_demo hp_sp_center">
							<icon-font type="icon-richscan_icon" />
							<div>扫一扫</div>
						</div>
					</a-tooltip>
					<a-tooltip
						:getPopupContainer="
							(triggerNode) => {
								return triggerNode.parentNode
							}
						"
						placement="left"
					>
						<template slot="title">
							<div style="width: 120px;height: 120px;">
								<img
									style="width: 120px;height: 120px;"
									src="@/assets/advertising/uniapp.jpg"
									alt
								/>
							</div>
						</template>
						<div class="affix_demo hp_sp_center">
							<icon-font type="icon-guanzhu" />
							<div>关注我们</div>
						</div>
					</a-tooltip>
					<a-tooltip
						:getPopupContainer="
							(triggerNode) => {
								return triggerNode.parentNode
							}
						"
						placement="left"
					>
						<template slot="title">
							<!-- <div style="width: 120px;height: 120px;">
                <img style="width: 120px;height: 120px;" src="@/assets/advertising/code.jpg" alt />
              </div> -->
						</template>
						<div class="affix_demo hp_sp_center">
							<icon-font type="icon-app4" />
							<div>苹果下载</div>
						</div>
					</a-tooltip>
					<a-tooltip
						:getPopupContainer="
							(triggerNode) => {
								return triggerNode.parentNode
							}
						"
						placement="left"
					>
						<template slot="title">
							<div style="width: 120px;height: 120px;">
								<img
									style="width: 120px;height: 120px;"
									src="@/assets/advertising/app1.png"
									alt
								/>
							</div>
						</template>
						<div class="affix_demo hp_sp_center">
							<icon-font type="icon-app1" />
							<div>安卓下载</div>
						</div>
					</a-tooltip>

					<!-- <div class="affix_demo hp_sp_center">
            <icon-font type="icon-guanzhu" />
            <div>关注我们</div>
          </div>
          <div class="affix_demo hp_sp_center">
            <icon-font type="icon-app4" />
            <div>苹果下载</div>
          </div>
          <div class="affix_demo hp_sp_center">
            <icon-font type="icon-app1" />
            <div>安卓下载</div>
          </div> -->
				</div>
			</a-affix>
		</div>
	</div>
</template>
<script>
import pcFooter from '@/components/Footer'
import pcHeader from '@/components/Header'
export default {
	components: {
		pcFooter,
		pcHeader,
	},
	data() {
		return {
			routes: this.$route.matched,
			list: [
				{
					name: '扫一扫',
					icon: 'icon-richscan_icon',
					img: require('@/assets/advertising/code.jpg'),
				},
			],
		}
	},
	watch: {
		$route() {
			(this.routes = this.$route.matched),
				// console.log("路由变化===", this.$route.matched);
				this.getBreadcrumb()
		},
	},
	created() {},
	mounted() {
		this.getBreadcrumb()
	},
	methods: {
		getBreadcrumb() {
			this.routes = this.routes.filter((item) => !item.meta.hidden)
		},
	},
}
</script>
<style lang="less" scoped>
.breadcrumb {
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 15px;
	margin-bottom: 15px;
}
.affix_demo {
	cursor: pointer;
	margin-bottom: 11px;
	flex-wrap: wrap;
	width: 76px;
	height: 76px;
	background: #ffffff;
	box-shadow: -2px 0px 6px 1px rgba(196, 196, 196, 0.38);
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #929292;
	/deep/ .anticon {
		margin-top: 14px;
		font-size: 24px;
		color: #666;
	}
	div {
		width: 87px;
		text-align: center;
	}
}
.backTop {
	/deep/ .anticon {
		font-size: 24px;
		color: #666;
	}
}
</style>
